import Graphene from "@snapchat/graphene";
import { reportWebAction, WebActionName, } from "@snapchat/web-blizzard-reporting";
import { SuppressedDefaultActionLink } from "@snapchat/web-core-ui";
import { ButtonColor, ColoredButton } from "@snapchat/web-sds-c";
import { getDeviceName, incrementCounter } from "@snapchat/web-graphene-reporting";
import { useCallback, useContext } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./OpenInAppCTA.module.css";
import { grafanaBasePrefix } from "../../../../../lib/grafana";
import { PageContext } from "@snapchat/web-frame";
/**
 * CTA button that deeplinks into the app
 */
export function OpenInAppCTA({ openInSnapchatLink, pageType, actionSource }) {
    const { webClientId } = useContext(PageContext);
    /* istanbul ignore next : Remove once test code is added */
    const logOpenInAppMetrics = useCallback(async () => {
        // Same behaviour as the "Open in Snapchat" button on the CTA footer.
        reportWebAction({
            pageType,
            actionName: WebActionName.OpenInSnapchatCta,
            deepLinkUrl: openInSnapchatLink,
            actionSource,
            webClientId: webClientId ?? "",
        });
        void incrementCounter(`${grafanaBasePrefix}.OpenInApp.byDeviceName.${getDeviceName()}.Click`);
        await Graphene.flush();
    }, [pageType, openInSnapchatLink, actionSource, webClientId]);
    return (<div data-testid="open_in_app_cta" className={styles.openInSnapchatCTA}>
      <SuppressedDefaultActionLink link={openInSnapchatLink} logMetric={logOpenInAppMetrics}>
        <ColoredButton color={ButtonColor.BLUE}>
          <span className={styles.ctaText}>
            <FormattedMessage description="Deeplink on the mobile footer when live lens is active" defaultMessage="Open in App"/>
          </span>
        </ColoredButton>
      </SuppressedDefaultActionLink>
    </div>);
}
